import { VerifyProvisionalRegistrationTokenWithBizsolMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const verifyProvisionalRegistrationTokenWithBizsolMutationHandler =
  graphql.mutation<VerifyProvisionalRegistrationTokenWithBizsolMutation>(
    "verifyProvisionalRegistrationTokenWithBizsol",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          verifyProvisionalRegistrationTokenWithBizsol: {
            email: "mock_user@moneyforward.com",
            registrationCode: "mock-registration-code",
            result: true,
          },
        },
      });
    }
  );
